import React, { memo } from 'react';
import css from './ButtonList.module.scss';

interface ComponentProps {
    /**
     * Unique name for component. Used for unique keys
     */
    name: string;
    /**
     * Buttons to left align
     */
    leftButtons?: (JSX.Element | null)[];
    /**
     * Button to right align
     */
    rightButtons?: (JSX.Element | null)[];
}

/**
 * Container that left or right aligns buttons
 */
export const GMButtonList: React.FC<ComponentProps> = memo((props) => {
    return (
        <div className={css.root}>
            {props.leftButtons ?
                <div className={css.left}>
                    {props.leftButtons.map((button, index) => <React.Fragment key={`buttonlist-left-${props.name}-${index}`}>{button}</React.Fragment>)}
                </div> : null
            }
            {props.rightButtons ?
                props.rightButtons.map((button, index) => <React.Fragment key={`buttonlist-right-${props.name}-${index}`}>{button}</React.Fragment>) : null
            }
        </div>
    );
});